export const calculateEndDate = (startDate, duration, workingSat, workingSun) => {
  if (!startDate) return null;
  
  let workingDaysRemaining = duration || 1;
  const endDate = new Date(startDate);
  endDate.setHours(0, 0, 0, 0);
  
  // Safety counter to prevent infinite loops
  let safetyCounter = 0;
  
  while (workingDaysRemaining > 0 && safetyCounter < 3650) {
    safetyCounter++;
    const dayOfWeek = endDate.getDay();
    const isSaturday = dayOfWeek === 6;
    const isSunday = dayOfWeek === 0;
    
    let isWorkingDay = true;
    if (isSaturday && !workingSat) isWorkingDay = false;
    if (isSunday && !workingSun) isWorkingDay = false;
    
    if (isWorkingDay) {
      workingDaysRemaining--;
    }
    
    if (workingDaysRemaining > 0) {
      endDate.setDate(endDate.getDate() + 1);
    }
  }
  
  return endDate;
};
